var _desc, _defs, _use, _path, _g, _use2, _use3, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "65px",
    viewBox: "0 0 72 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-tertiary-resilience") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.2351515%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.062500,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.500000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.093750,1.000000),rotate(90.000000),scale(1.000000,10.390143),translate(-0.489155,-0.509384)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.5123255%",
    y1: "71.3359426%",
    x2: "19.6413923%",
    y2: "21.3092469%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "99.21875%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "18.8951647%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.25,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.885115607%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.395441927,11.3176747 L17.4086387,0.135205148 C17.542835,0.0470003351 17.6999125,1.01965282e-14 17.8605012,0 L46.1394536,0 C46.3000423,1.22770002e-14 46.4571198,0.0470003351 46.5913161,0.135205148 L63.6045128,11.3176747 C63.9841927,11.5672315 64.0896783,12.0773285 63.8401215,12.4570084 C63.8244176,12.4809006 63.8074789,12.5039578 63.7893742,12.5260864 L32.6367013,50.6027032 C32.3489938,50.9543561 31.8306898,51.0061941 31.4790369,50.7184866 C31.436688,50.6838386 31.3979015,50.645052 31.3632535,50.6027032 L0.210580511,12.5260864 C-0.0771269844,12.1744335 -0.0252889848,11.6561294 0.326363924,11.368422 C0.348492452,11.3503173 0.371549741,11.3333786 0.395441927,11.3176747 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1394536,0 C46.3000423,1.22770002e-14 46.4571198,0.0470003351 46.5913161,0.135205148 L63.6045128,11.3176747 C63.9841927,11.5672315 64.0896783,12.0773285 63.8401215,12.4570084 C63.8244176,12.4809006 63.8074789,12.5039578 63.7893742,12.5260864 L32.6367013,50.6027032 C32.3489938,50.9543561 31.8306898,51.0061941 31.4790369,50.7184866 C31.436688,50.6838386 31.3979015,50.645052 31.3632535,50.6027032 L0.210580511,12.5260864 C-0.0771269844,12.1744335 -0.0252889848,11.6561294 0.326363924,11.368422 C0.348492452,11.3503173 0.371549741,11.3333786 0.395441927,11.3176747 L17.4086387,0.135205148 C17.542835,0.0470003351 17.6999125,1.01965282e-14 17.8605012,0 L46.1394536,0 Z M28.9148408,20.5484882 L28.9148408,20.5484882 L28.9153777,28.1324962 C28.9277516,30.3191814 29.1721656,30.7826932 31.4880886,30.7826932 L31.4880886,30.7826932 L33.2659688,30.7826932 L33.2659688,35.4569695 L23.2777482,35.456619 L31.837767,45.9480654 C31.8466871,45.9589975 31.8566894,45.9689998 31.8676215,45.9779199 C31.9572125,46.0510228 32.089102,46.0376565 32.1622049,45.9480654 L32.1622049,45.9480654 L40.4699635,35.7667764 C37.4241318,34.8306533 36.0263619,32.4832841 36.0263619,28.4209536 L36.0263619,28.4209536 L36.0257526,25.4222448 C36.0058624,21.5872209 35.4802032,20.5484882 31.7220202,20.5484882 L31.7220202,20.5484882 Z M14.3637482,5.88161905 L4.77606674,12.0455978 C4.76278739,12.0541343 4.75000141,12.063415 4.73777003,12.0733953 C4.55858791,12.2196011 4.53185532,12.4833801 4.67806113,12.6625623 L4.67806113,12.6625623 L18.4364693,29.5225887 C18.5131245,29.1215921 18.5282771,28.6009508 18.5282771,27.9289245 L18.5282771,27.9289245 L18.5277719,9.72289017 C18.515788,7.53397758 18.2729575,7.11609427 15.9550294,7.11609427 L15.9550294,7.11609427 L14.3642944,7.11609427 L14.3637482,5.88161905 Z M41.3623619,3.04692978 C45.353222,4.11831687 47.348652,6.62424281 47.348652,10.6587037 C47.348652,14.3489218 45.0093359,17.0058788 40.7049942,17.9407341 C45.8514897,18.5803719 46.178994,21.0897202 46.178994,27.5353012 C46.178994,27.9803155 46.1893434,28.37744 46.2148315,28.7271326 L46.2148315,28.7271326 L59.3219108,12.6625623 L59.3219108,12.6625623 L59.3497084,12.6242656 C59.4747635,12.4297313 59.4184395,12.1706529 59.2239052,12.0455978 L59.2239052,12.0455978 L45.2267547,3.04761905 Z M28.6051153,7.46602717 L28.6051153,7.46602717 L28.6051153,15.9166267 L31.449773,15.9166267 L31.7115136,15.9149952 C35.2416933,15.8701741 36.8498012,14.8925171 36.8498012,11.8337528 C36.8498012,8.46300801 35.3551505,7.46602717 31.7872748,7.46602717 L31.7872748,7.46602717 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.75,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "32.1500211%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "37.7754807%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.885115607%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.7220202,20.5484882 C35.5584987,20.5484882 36.0263619,21.6309522 36.0263619,25.6655907 L36.0263619,28.4209536 C36.0263619,32.4832841 37.4241318,34.8306533 40.4699635,35.7667764 L32.1622049,45.9480654 C32.089102,46.0376565 31.9572125,46.0510228 31.8676215,45.9779199 C31.8566894,45.9689998 31.8466871,45.9589975 31.837767,45.9480654 L23.2777482,35.456619 L33.2659688,35.4569695 L33.2659688,30.7826932 L31.4880886,30.7826932 C29.1019861,30.7826932 28.9148408,30.2906641 28.9148408,27.9289245 L28.9148408,20.5484882 Z M14.3637482,5.88161905 L14.3642944,7.11609427 L15.9550294,7.11609427 C18.3411318,7.11609427 18.5282771,7.55892044 18.5282771,9.92066004 L18.5282771,27.9289245 C18.5282771,28.6009508 18.5131245,29.1215921 18.4364693,29.5225887 L4.67806113,12.6625623 C4.53185532,12.4833801 4.55858791,12.2196011 4.73777003,12.0733953 C4.75000141,12.063415 4.76278739,12.0541343 4.77606674,12.0455978 L14.3637482,5.88161905 Z M45.2267547,3.04761905 L59.2239052,12.0455978 C59.4184395,12.1706529 59.4747635,12.4297313 59.3497084,12.6242656 C59.3411718,12.6375449 59.3318912,12.6503309 59.3219108,12.6625623 L46.2148315,28.7271326 C46.1893434,28.37744 46.178994,27.9803155 46.178994,27.5353012 C46.178994,21.0897202 45.8514897,18.5803719 40.7049942,17.9407341 C45.0093359,17.0058788 47.348652,14.3489218 47.348652,10.6587037 C47.348652,6.62424281 45.353222,4.11831687 41.3623619,3.04692978 L45.2267547,3.04761905 Z M31.7872748,7.46602717 C35.3551505,7.46602717 36.8498012,8.46300801 36.8498012,11.8337528 C36.8498012,14.9671211 35.1622924,15.9166267 31.449773,15.9166267 L31.449773,15.9166267 L28.6051153,15.9166267 L28.6051153,7.46602717 Z",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.1%",
    y: "-5.2%",
    width: "108.1%",
    height: "110.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "HH---Employee-Wellbeing-Tracker",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wellbeing-Tracker-1st-Use-LG-03.0.0",
    transform: "translate(-486.000000, -2177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hrs-Per-Week",
    transform: "translate(458.000000, 2146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-tertiary-resilience",
    transform: "translate(32.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow-large",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-1)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 32,
    cy: 2,
    rx: 32,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-2)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 32,
    cy: 1.5,
    rx: 16,
    ry: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    strokeWidth: 1,
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-4)",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "multiply"
    },
    xlinkHref: "#path-6"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#linearGradient-5)",
    strokeWidth: 3.29070534,
    d: "M-0.508283073,9.94273231 L16.5049137,-1.23973723 C16.9075025,-1.50435166 17.3787351,-1.64535267 17.8605012,-1.64535267 L46.1394536,-1.64535267 C46.6212197,-1.64535267 47.0924522,-1.50435166 47.4950411,-1.23973723 L64.5082378,9.94273231 C65.6472774,10.6914026 65.9637342,12.2216938 65.2150639,13.3607334 C65.1679522,13.4324099 65.1171359,13.5015818 65.0628221,13.5679674 L33.9101491,51.6445842 C33.0470266,52.6995429 31.4921146,52.8550569 30.4371559,51.9919344 C30.3101093,51.8879903 30.1937497,51.7716307 30.0898056,51.6445842 L-1.06286732,13.5679674 C-1.92598981,12.5130087 -1.77047581,10.9580966 -0.715517082,10.0949741 C-0.649131495,10.0406603 -0.579959629,9.98984402 -0.508283073,9.94273231 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shine"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#575756",
    opacity: 0,
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-9)",
    mask: "url(#mask-8)",
    cx: 32,
    cy: 28.4952381,
    rx: 32,
    ry: 17.5238095
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "#2CB5D6",
    fillRule: "evenodd",
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-10)",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "multiply"
    },
    xlinkHref: "#path-12"
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-13)",
    xlinkHref: "#path-12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#linearGradient-11)",
    strokeWidth: 0.732791328,
    d: "M32.8995732,35.090561 L32.8995732,31.1490889 L31.4880886,31.1490889 C28.9917873,31.1490889 28.5484451,30.6117258 28.5484451,27.9289245 L28.5484451,20.1820926 L31.7220202,20.1820926 C35.6021997,20.1820926 36.3927575,21.2091055 36.3927575,25.6655907 L36.3927575,28.4209536 C36.3927575,32.3482231 37.7108458,34.5354633 40.5776044,35.416549 L41.0981035,35.5765222 L32.4460881,46.1797033 C32.2450552,46.4260788 31.882359,46.4628361 31.6359836,46.2618031 C31.5921673,46.2235196 31.5921673,46.2235196 31.5538758,46.1796935 L22.5059046,35.0901963 L32.8995732,35.090561 Z M14.730528,6.7496986 L15.9550294,6.7496986 C18.4632471,6.7496986 18.8946728,7.257238 18.8946728,9.92066004 L18.8946728,27.9289245 C18.8946728,28.7338615 18.8710644,29.2005317 18.7963484,29.5913838 L18.6489441,30.3624808 L4.39417794,12.8942002 C4.12004205,12.5582337 4.17016566,12.063648 4.50613214,11.7895121 C4.54105282,11.7620984 4.54105282,11.7620984 4.57792483,11.7374005 L14.7298471,5.21066794 L14.730528,6.7496986 Z M45.424883,2.739413 L59.4220335,11.7373917 C59.7867853,11.9718701 59.8923928,12.4576421 59.6579144,12.8223938 C59.6332078,12.8592795 59.6332078,12.8592795 59.6058027,12.8941896 L45.9163701,29.6725157 L45.8494052,28.7537675 C45.8241882,28.4077932 45.8125983,28.0090708 45.8125983,27.5353012 C45.8125983,20.3388099 45.1020896,18.8564466 40.659804,18.3043323 L38.5257646,18.0391009 L40.6272301,17.5826859 C44.7322484,16.6911215 46.9822564,14.2016563 46.9822564,10.6587037 C46.9822564,6.80385164 45.1118295,4.43288179 41.267363,3.40079557 L38.5825804,2.68003829 L45.22682,2.68122339 L45.424883,2.739413 Z M31.7872748,7.09963151 C35.6811344,7.09963151 37.2161968,8.35553161 37.2161968,11.8337528 C37.2161968,15.0773515 35.5181459,16.2830223 31.449773,16.2830223 L28.2387197,16.2830223 L28.2387197,7.09963151 L31.7872748,7.09963151 Z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIcon);
export default __webpack_public_path__ + "static/media/shield-icon.9f314a3c07deba47a500255c02c2bce0.svg";
export { ForwardRef as ReactComponent };